define('editor/edit/layers/edit/boundaries',['jquery', 'durandal/app', 'plugins/http', 'knockout', 'knockout-mapping', 'no-ui-slider', 'tinycolorpicker'], function ($, app, http, ko, komapping, noUiSlider) {
    var viewmodel = function () {
        var self = this;

        self.layer = null;
        self.backup = null;
        self.backupLayers = [];
        self.name = ko.observable();
        self.isDirty = true; // assume edited

        // editable vector style properties
        self.fillColor = ko.observable('#000000');
        self.fillOpacity = ko.observable(100);
        self.strokeColor = ko.observable('#000000');
        self.strokeWeight = ko.observable(1);
        self.strokeOpacity = ko.observable(100);
        self.selectedTextSize = ko.observable('normal');
        self.labelVisible = ko.observable(true);
        self.labelTextColor = ko.observable();
        self.labelShadowColor = ko.observable();
        self.textShadow = ko.observable(false);


        self.activate = function (editorMapId, group, layers, backToListFunc) {
            self.editorMapId = editorMapId;
            self.group = group;
            self.backup = group;
            self.layers = layers;
            self.exit = backToListFunc;
            self.name(group.name());

            self.backupChildLayers();

            var firstLayer = self.layers[0];
            var state = firstLayer.state();
            self.fillColor(state.fillColor());
            self.fillOpacity(state.fillOpacity() * 100);
            self.strokeColor(state.color());
            self.strokeWeight(state.weight());
            self.strokeOpacity(state.opacity() * 100);
            self.selectedTextSize(state.textSize());
            self.labelVisible(state.labelVisible());
            self.labelTextColor(state.labelTextColor());
            self.labelShadowColor(state.textShadowColor());
            self.textShadow(state.textShadow() === "on");

            self.changes = ko.computed(function () {
                return self.fillColor() +
                    self.fillOpacity() +
                    self.strokeColor() +
                    self.strokeWeight() +
                    self.strokeOpacity() +
                    self.selectedTextSize() +
                    self.textShadow() +
                    self.labelVisible() +
                    self.labelTextColor() +
                    self.labelShadowColor();
            });

            self.changes.subscribe(function () {
                for (var i = 0; i < self.layers.length; i++) {
                    var layer = self.layers[i];
                    layer.state().fillColor(self.fillColor());
                    layer.state().fillOpacity(self.fillOpacity() / 100);
                    layer.state().color(self.strokeColor());
                    layer.state().opacity(self.strokeOpacity() / 100);
                    layer.state().weight(self.strokeWeight());
                    layer.state().textSize(self.selectedTextSize());
                    layer.state().textShadow(self.textShadow() ? "on" : "off");
                    layer.state().labelVisible(self.labelVisible());
                    layer.state().labelTextColor(self.labelTextColor());
                    layer.state().textShadowColor(self.labelShadowColor());
                }
                app.trigger("layers:updated", self.layers);
            });

            app.on('layers:drawing', function () {
                self.cancelCommand();
            });
        };

        self.backupChildLayers = function () {
            var layersLen = self.layers.length,
                layer;

            for (var i = 0; i < layersLen; i++) {
                layer = self.layers[i];
                layer.state().labelText(layer.state().labelText().unescapeNewLines());

                self.backupLayers.push(ko.toJS(layer));
            }
        };

        self.compositionComplete = function () {
            // set up jQuery plugins etc..
            var fillSlider = $('.slider-fill'),
                fillSliderStart = self.fillOpacity(),
                fillColorPicker,
                strokeSlider = $('.slider-stroke'),
                strokeSliderStart = self.strokeOpacity(),
                strokeColorPicker,
                labelColorPicker,
                labelShadowColorPicker;


            if (fillSlider.length) {
                noUiSlider.create(fillSlider.get(0),
                {
                    start: fillSliderStart,
                    step: 1,
                    tooltips: true,
                    connect: "lower",
                    orientation: "horizontal",
                    range: {
                        'min': 0,
                        'max': 100
                    },
                    serialization: {
                        format: {
                            decimals: 0
                        }
                    }
                });

                fillSlider.get(0).noUiSlider.on('change', function () {
                    var newValue = fillSlider.get(0).noUiSlider.get();
                    self.fillOpacity(newValue);
                });
            }

            if (strokeSlider.length) {
                noUiSlider.create(strokeSlider.get(0),
                {
                    start: strokeSliderStart,
                    step: 1,
                    tooltips: true,
                    connect: "lower",
                    orientation: "horizontal",
                    range: {
                        'min': 0,
                        'max': 100
                    },
                    serialization: {
                        format: {
                            decimals: 0
                        }
                    }
                });

                strokeSlider.get(0).noUiSlider.on('change', function () {
                    var newValue = strokeSlider.get(0).noUiSlider.get();
                    self.strokeOpacity(newValue);
                });
            }

            strokeColorPicker = $('.color-picker-stroke').tinycolorpicker();
            strokeColorPicker.data().plugin_tinycolorpicker.setColor(self.strokeColor());
            strokeColorPicker.bind("change", function () {
                var newColor = $(this).data().plugin_tinycolorpicker.colorHex;
                self.strokeColor(newColor);
            });

            fillColorPicker = $('.color-picker-fill').tinycolorpicker();
            fillColorPicker.data().plugin_tinycolorpicker.setColor(self.fillColor());
            fillColorPicker.bind("change", function () {
                var newColor = $(this).data().plugin_tinycolorpicker.colorHex;
                self.fillColor(newColor);
            });

            labelColorPicker = $('.color-picker-text').tinycolorpicker();
            labelColorPicker.data().plugin_tinycolorpicker.setColor(self.labelTextColor());
            labelColorPicker.bind("change", function () {
                var newColour = $(this).data().plugin_tinycolorpicker.colorHex;
                self.labelTextColor(newColour);
            });

            labelShadowColorPicker = $('.color-picker-shadow').tinycolorpicker();
            labelShadowColorPicker.data().plugin_tinycolorpicker.setColor(self.labelShadowColor());
            labelShadowColorPicker.bind("change", function () {
                var newColour = $(this).data().plugin_tinycolorpicker.colorHex;
                self.labelShadowColor(newColour);
            });

        };

        self.detached = function () {
            if (self.isDirty) {
                self.cancelCommand();
            }
        };

        self.cancelCommand = function () {
            // revert to initial layer state, for each layer
            var layersLen = self.layers.length,
                layer,
                backup,
                mappedState;

            for (var i = 0; i < layersLen; i++) {
                layer = self.layers[i];
                backup = self.backupLayers[i];
                mappedState = komapping.fromJS(backup.state);

                delete mappedState['__ko_mapping__'];

                layer.state(mappedState);
            }

            app.trigger("layers:updated", self.layers);
            self.group.name(self.backup.name());
            self.isDirty = false;
            self.exit();
        };

        self.saveCommand = function () {
            self.group.name(self.name());

            self.save()
                .then(function () {
                    self.isDirty = false;
                    self.exit();
                })
                .fail(app.showError);
        };

        self.save = function () {
            var url = '/api/editor/layers/group/details',
                data = {
                    editorMapId: self.editorMapId,
                    groupId: self.group.id(),
                    groupName: self.group.name(),
                    groupCollapsed: self.group.isCollapsed(),
                    childLayerStates: {}
                },
                layersLen = self.layers.length,
                layer;

            for (var i = 0; i < layersLen; i++) {
                layer = self.layers[i];

                data.childLayerStates[layer.id()] = ko.toJS(layer.state());
            }

            return http.post(url, data)
                .fail(app.showError);
        };
    };

    return viewmodel;
});

